<div *ngIf="isDev" class="env-badge">
    <span class="env-badge-full">Ambiente de Desarrollo</span>
    <span class="env-badge-short">DEV</span>
</div>
<div class="min-h-screen flex items-center justify-center">
    <div class="max-w-[414px] w-full">
        <div class="px-6 py-8 bg-blue-secondary shadow-dm rounded-sm mb-7">
            <div class="flex items-center justify-center mb-6">
                <img src="../../../assets/img/sige.png" alt="SIGE" class="h-[22px] w-auto mr-2">
                <span class="text-white text-2xl font-semibold">SIGE</span>
            </div>
            <form [formGroup]="passwordResetForm" (ngSubmit)="onSubmit()">
                <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
                    <mat-label class="text-gray text-lg">Correo Electrónico</mat-label>
                    <input matInput type="email" formControlName="email" class="text-lg text-white bg-blue-primary" required>
                    <mat-error *ngIf="emailControl?.invalid && (emailControl?.dirty || emailControl?.touched)">
                        <span *ngIf="emailControl?.errors?.['required']">El correo electrónico es requerido.</span>
                        <span *ngIf="emailControl?.errors?.['email']">Ingrese un formato de correo electrónico válido.</span>
                    </mat-error>
                </mat-form-field>
                <div>
                    <button matButton type="submit" class="w-full">Enviar enlace de restablecimiento</button>
                </div>
            </form>
        </div>
        <div class="flex justify-center">
            <a [routerLink]="['/']" class="text-white text-sm">Regresar al Inicio de Sesión</a>
        </div>
    </div>
</div>
